module.exports = {
  "testing-123": {
    "en": "Latest publications",
    "zh": "最新發表"
  }
}
